import { h } from "@stencil/core";
import { TableCellProps } from "../table-cell";

export const renderStatus = ({
    item,
    columnKey,
    schemaItem,
    translate,
}: TableCellProps) => (
    <td data-testid={columnKey}>
        {item[columnKey] && (
            <ux-w-status type={item[columnKey]}>
                {schemaItem.labels?.[item[columnKey]] ||
                    translate(`${columnKey}.values.${item[columnKey]}`)}
            </ux-w-status>
        )}
        {!item[columnKey] && columnKey === "softwareUpdates" && <span>-</span>}
    </td>
);
